import { motion } from 'motion/react';
import { observer } from 'mobx-react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';

import { P } from '../typography/new';
import { Button } from '../button/new';
import { IOSButtonWrapper } from '../ios-button-wrapper';

// Local layout wrapper replacing unused Tailwind utility classes.
const ButtonContentRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

// Groups price + kilojoules;
const PriceDetails = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;

const Separator = styled.span`
  margin: 0 6px;
  font-size: 16px;
  font-weight: 400;
  opacity: 0.5;
`;

const ConfirmButton = observer(
  ({ analytics, onClick, isFullWidth, buttonText, price, kilojoules, disabled, padding }) => {
    const buttonProps = {
      analytics,
      onClick,
      variant: 'primary',
      isFullWidth,
      disabled,
    };

    return (
      <IOSButtonWrapper padding={padding}>
        <Button
          {...buttonProps}
          as={motion.button}
          initial={{ y: 100 }}
          animate={{ y: 0 }}
          transition="0.2s ease-in-out 0.3s"
          size="tall"
          widthStyle="full"
          style={{ width: '100%' }}
          px="32px"
        >
          <ButtonContentRow>
            {buttonText}
            <PriceDetails>
              <P as="div" variant="small">
                {price}
              </P>
              <Separator>/</Separator>
              <P as="div" variant="small" textTransform="uppercase">
                {kilojoules}
              </P>
            </PriceDetails>
          </ButtonContentRow>
        </Button>
      </IOSButtonWrapper>
    );
  }
);

ConfirmButton.propTypes = {
  analytics: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.string.isRequired,
  isFullWidth: PropTypes.bool,
  price: PropTypes.string,
  kilojoules: PropTypes.string,
  buttonText: PropTypes.string,
  disabled: PropTypes.bool,
  padding: PropTypes.string,
};

ConfirmButton.defaultProps = {
  isFullWidth: undefined,
  analytics: undefined,
  price: undefined,
  kilojoules: undefined,
  buttonText: 'Add to order',
  disabled: false,
  padding: undefined,
};

export { ConfirmButton };
